export const LoadingSelectors = {
  spinner: '.spinner',
  loadingOverlay: '.loading-overlay',
  loadingIndicators: [
    '.loading-logo',
    '.loading-spinner',
    '.loading-overlay',
    '.loading-overlay__spinner',
    '.loading-span',
    '.loading-indicator',
    '#loading__logo',
    '#loading__spinner',
    '.mm-button-base__icon-loading',
    '.loading-swaps-quotes',
    '.loading-heartbeat'
  ]
}
